export default {
    SET_STATUSES_PAGINATED(state, statuses) {
        state.statuses = statuses;
    }
}